import "./Category.scss";
export const CategoryItem = ({
  title,
  backgroundColor,
  img,
  //onClickHandler,
}) => {
  return (
    <div className="parent-cetegory">
      <div className="card-cat" style={{ borderRadius: "80%" }}>
        <div
          className="card-body"
          style={{ cursor: "pointer", backgroundColor: { backgroundColor } }}
          //onClick={onClickHandler}
        >
          <img src={img} alt={`${title}`} />
          <br />
        </div>
      </div>

      <div className="title ">{title} </div>
    </div>
  );
};
